import { workSetCheckGroupSchemaAPI } from "./api";

export const getProjectTypes = async () => {
  try {
    const res = await workSetCheckGroupSchemaAPI.getProjectTypes();
    return res?.data;
  } catch (e) {
  }
};

export const getWorkSetCheckGroups = async () => {
  try {
    const res = await workSetCheckGroupSchemaAPI.getWorkSetCheckGroups();
    return res?.data;
  } catch (e) {
  }
};

export const getWorkSetCheckGroupsByProjectType = async (projectTypeId) => {
  if(!projectTypeId) return
  try {
    const res =
      await workSetCheckGroupSchemaAPI.getWorkSetCheckGroupsByProjectType(
        projectTypeId
      );
    return res?.data;
  } catch (e) {
  }
};

export const getBpmnSchemas = async () => {
  try {
    const res = await workSetCheckGroupSchemaAPI.getBpmnSchemas();
    return res?.data;
  } catch (e) {
  }
};

export const getWorkSetCheckGroupSchemas = async (params = {}) => {
  try {
    const res = await workSetCheckGroupSchemaAPI.getRows(params);
    return res?.data;
  } catch (e) {
  }
};

export const modifyWorkSetCheckGroupSchema = async (body) => {
  try {
    const res = await workSetCheckGroupSchemaAPI.modify(body);
    return res?.data;
  } catch (e) {
  }
};

export const deleteWorkSetCheckGroupSchema = async (workSetCheckGroupSchemaId) => {
  try {
    const res = await workSetCheckGroupSchemaAPI.deleteRow(
      workSetCheckGroupSchemaId
    );
    return res?.data;
  } catch (e) {
  }
};

export const workSetCheckGroupSchemaColumns = [
  {
    name: "project_type_name",
    field: "project_type_name",
    label: "Тип проекта",
    align: "left",
  },
  {
    name: "work_set_check_group_name",
    field: "work_set_check_group_name",
    label: "Группа работ",
    align: "left",
  },
  {
    name: "schema_id",
    field: "schema_id",
    label: "ID схемы",
    align: "right",
  },
];
